import { css } from 'react-emotion'

const styles = {
  videoItemsWrap: css({
    width: '100%',
    display: 'grid',
    gridGap: '24px',
    gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
  }),
}

export default styles



// WEBPACK FOOTER //
// ./src/Pages/Videos/ListStyles.js